

import React, {useMemo } from 'react';
import { Table } from 'tea-component';
import {shallowEqual, useSelector, useIntl } from 'umi';
import { IRightTable } from './_type';

const { removeable, draggable, autotip } = Table.addons;

const  RightTable =(props: IRightTable) => {
  const {
    dataSource,
    onRemove,
    onDragEnd,
    loading,
    columns
  } = props || {};
  const { formatMessage } = useIntl();


  const { unifiedId } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
    unifiedId: state?.dashboardSetting?.gameConfig?.unifiedid || '',
  }), shallowEqual);
  const realDataSource = useMemo(() => dataSource?.filter(
    (item: any) => item.game_id !== unifiedId,
  ), [dataSource, unifiedId]);

  return (
    <div className="target-table">
      <div className="target-table-header">
        {formatMessage({id: 'benchmark_comparison'})}
      </div>
      <Table
        records={realDataSource}
        hideHeader={true}
        recordKey="game_id"
        className="dbd-right-table"
        // columns={columns(gameCountryMap)}
        rowClassName={() => 'table-row'}
        columns={columns}
        addons={[
          removeable({ onRemove }),
          draggable({ onDragEnd }),
          autotip({ isLoading: loading }),
        ]}
      />
    </div>
  );
};

export default RightTable;

